import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TaskFiltersAdvancedComponent } from '@app/components/task/task-list-toolbar/task-filters-advanced/task-filters-advanced.component';
import { TaskSortControlsComponent } from '@app/components/task/task-list-toolbar/task-sort-controls/task-sort-controls.component';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Mobile-only shell for advanced task filters.
 *
 * Dumb dialog: hosts {@link TaskFiltersAdvancedComponent} and sort controls.
 * Filter and sort changes apply immediately via route-scoped {@link TaskFiltersService}.
 */
@Component({
  selector: 'proffeo-task-advanced-filters-dialog',
  templateUrl: './task-advanced-filters-dialog.component.html',
  imports: [
    TranslatePipe,
    UiDialogComponent,
    UiButtonComponent,
    TaskFiltersAdvancedComponent,
    TaskSortControlsComponent
  ]
})
export class TaskAdvancedFiltersDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<TaskAdvancedFiltersDialogComponent>);

  protected close(): void {
    this.dialogRef.close();
  }
}
